import { useCallback } from 'react'
import ApiService from '../../../../services/ApiService'

const InteractorMasterMenuSearch = () => {
  const searchMenuTeam = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/master-menu/team-search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { searchMenuTeam }
}

export default InteractorMasterMenuSearch
